import React, { HTMLAttributes, useEffect, useRef, useState } from 'react';
import IconButton from '../IconButton/IconButton';
import { isString } from 'lodash';
import { Link } from 'react-router-dom';

interface IContextMenuItem {
  text: string;
  onClick?: HTMLAttributes<HTMLDivElement>['onClick'] | string;
}

interface IPropertiesIconWithContexMenu
  extends Omit<HTMLAttributes<HTMLButtonElement>, 'onClick'> {
  icon: string;
  contextMenuLimit?: 'l' | 'r';
  contextMenuItems: IContextMenuItem[];
}

const IconWithContextMenu = (properties: IPropertiesIconWithContexMenu) => {
  const [showContextMenu, setShowContextMenu] = useState(false);

  const contextMenuReference = useRef<HTMLDivElement>(null);

  const {
    icon,
    contextMenuLimit = 'l',
    contextMenuItems,
    ...remainigProperties
  } = properties;

  const handleOpen = () => setShowContextMenu(true);

  const handleClose = () => setShowContextMenu(false);

  useEffect(() => {
    const handleClickOutsideContextMenu = (event: MouseEvent) => {
      if (
        contextMenuReference.current &&
        event.target instanceof Element &&
        !contextMenuReference.current.contains(event.target)
      ) {
        handleClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutsideContextMenu);

    return () => {
      document.removeEventListener('mousedown', handleClickOutsideContextMenu);
    };
  }, []);

  return (
    <div className="relative">
      <IconButton {...remainigProperties} icon={icon} onClick={handleOpen} />
      <div
        className={` shadow-theme-shadow/50 shadow-lg absolute flex flex-col gap-1 min-w-[196px] rounded-sm top-10 ${
          contextMenuLimit === 'r' ? 'right-0' : 'left-0'
        } bg-theme-gray p-1 ${showContextMenu ? 'visible' : 'invisible'}`}
        ref={contextMenuReference}
      >
        {contextMenuItems.map((contextMenuItem) => {
          if (isString(contextMenuItem.onClick)) {
            return (
              <Link
                onClick={handleClose}
                to={contextMenuItem.onClick}
                className=" hover:bg-theme-lighter-gray/50 cursor-pointer rounded-sm pointer-events-auto p-2"
                key={contextMenuItem.text}
              >
                {contextMenuItem.text}
              </Link>
            );
          } else {
            const newOnClick = (event: React.MouseEvent<HTMLDivElement>) => {
              contextMenuItem.onClick &&
                !isString(contextMenuItem.onClick) &&
                contextMenuItem.onClick(event);
              handleClose();
            };

            return (
              <div
                onClick={newOnClick}
                className=" hover:bg-theme-lighter-gray/50 cursor-pointer rounded-sm pointer-events-auto p-2"
                key={contextMenuItem.text}
              >
                {contextMenuItem.text}
              </div>
            );
          }
        })}
      </div>
    </div>
  );
};

export default IconWithContextMenu;
